import { Skeleton } from '~/components/ui/skeleton';

import { QcStepBodySkeleton } from '../qc/qc-page-skeleton';
import { ContentPage } from '../ui-kit/content-page';

import { CatalogJobHeaderSkeleton } from './catalog-job-header';

/** The catalog pages' Suspense fallback: the job header, a step strip placeholder and a body. */
export function CatalogPageSkeleton() {
  return (
    <ContentPage className="gap-5">
      <CatalogJobHeaderSkeleton />
      <Skeleton aria-hidden="true" className="h-11 w-96 max-w-full" />
      <QcStepBodySkeleton />
    </ContentPage>
  );
}
